(function () {
  const MOBILE_MAX = 749;

  const isMobile = () => window.matchMedia(`(max-width: ${MOBILE_MAX}px)`).matches;

  function formatCents(cents) {
    if (cents == null || cents === '') return '';
    const n = parseInt(cents, 10);
    if (!Number.isFinite(n)) return '';
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      let s = Shopify.formatMoney(n, Shopify.money_format);
      if (s) {
        s = s.replace(/\.00(?!\d)/, '').replace(/,00(?!\d)/, '');
      }
      return s;
    }
    return String(n / 100);
  }

  const init = () => {
    if (customElements.get('armonia-pdp-sticky-cta')) return;

    class ArmoniaPdpStickyCta extends HTMLElement {
      constructor() {
        super();
        this.onResize = this.onResize.bind(this);
        this.onStickyAdd = this.onStickyAdd.bind(this);
        this.syncPrices = this.syncPrices.bind(this);
        this.checkVisibility = this.checkVisibility.bind(this);
        this.onVariantInputChange = this.onVariantInputChange.bind(this);
      }

      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.sectionId = this.dataset.sectionId;
        this.isDual = this.dataset.isDual === 'true';
        this.mainBtn =
          document.querySelector(`#ProductSubmitButton-${this.sectionId}`) ||
          document.querySelector('.product-form__submit[name="add"]');
        this.priceTarget = this.querySelector('[data-sticky-cta-price]');
        this.msiTarget = this.querySelector('[data-sticky-cta-msi]');
        this.addBtn = this.querySelector('[data-sticky-cta-add]');
        this.sectionRoot =
          document.querySelector(`#shopify-section-${this.sectionId}`) ||
          document.querySelector(`[data-section="${this.sectionId}"]`);
        this.variantInput =
          document.querySelector(`#product-form-${this.sectionId} .product-variant-id`) ||
          document.querySelector(`#product-form-${this.sectionId} input[name="id"]`) ||
          document.querySelector('.product-variant-id');

        if (!this.mainBtn || !this.addBtn) {
          this.hidden = true;
          return;
        }

        this.addBtn.addEventListener('click', this.onStickyAdd);

        if (this.variantInput) {
          this.variantInput.addEventListener('change', this.onVariantInputChange);
        }

        const dualRoot = this.sectionRoot?.querySelector('.armonia-dual-price');
        if (dualRoot) {
          dualRoot.querySelectorAll('[data-armonia-payment]').forEach((col) => {
            col.addEventListener('click', () => requestAnimationFrame(this.syncPrices));
          });
        }

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.variantUnsub = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
            if (String(event.data.sectionId) !== String(this.sectionId)) return;
            requestAnimationFrame(this.syncPrices);
          });
        }

        if ('IntersectionObserver' in window) {
          this.io = new IntersectionObserver(
            (entries) => {
              const mainVisible = entries[0]?.isIntersecting;
              this.setBarVisible(!mainVisible);
            },
            { root: null, threshold: 0 }
          );
          this.io.observe(this.mainBtn);
        }

        window.addEventListener('scroll', this.checkVisibility, { passive: true });
        window.addEventListener('resize', this.onResize, { passive: true });
        this.fullAddLabel = null;
        this.syncAvailability();
        this.syncPrices();
        this.syncButtonLabel();
        this.checkVisibility();
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this.checkVisibility);
        window.removeEventListener('resize', this.onResize);
        if (this.variantInput) {
          this.variantInput.removeEventListener('change', this.onVariantInputChange);
        }
        if (this.io) this.io.disconnect();
        if (this.variantUnsub) this.variantUnsub();
        document.body.classList.remove('armonia-sticky-cta-visible');
        this.initialized = false;
      }

      onVariantInputChange() {
        requestAnimationFrame(this.syncPrices);
      }

      getVariantsJson() {
        const script = this.sectionRoot?.querySelector(
          'variant-selects script[type="application/json"], variant-radios script[type="application/json"]'
        );
        if (!script) return null;
        try {
          return JSON.parse(script.textContent).variants;
        } catch (_) {
          return null;
        }
      }

      findContadoMsiVariants(variants) {
        let contado = null;
        let msi = null;
        if (!variants) return { contado, msi };
        for (const v of variants) {
          const opts = [v.option1, v.option2, v.option3].filter(Boolean);
          if (opts.some((o) => /meses sin intereses/i.test(o))) msi = v;
          if (opts.some((o) => /pago contado/i.test(o))) contado = v;
        }
        return { contado, msi };
      }

      syncPrices() {
        if (!this.priceTarget) return;

        const variants = this.getVariantsJson();
        const dualBlock = this.sectionRoot?.querySelector('.armonia-dual-price');
        let contadoCents = parseInt(this.dataset.contadoCents, 10);
        let msiCents = parseInt(this.dataset.msiCents, 10) || 0;

        if (variants) {
          const { contado, msi } = this.findContadoMsiVariants(variants);
          if (contado) contadoCents = contado.price;
          if (msi) msiCents = msi.price;
          else if (!this.isDual && !dualBlock) {
            const vid = parseInt(this.variantInput?.value, 10);
            const current = variants.find((v) => v.id === vid);
            if (current) contadoCents = current.price;
          }
        }

        const contadoMoney = formatCents(contadoCents);
        if (contadoMoney) {
          this.priceTarget.textContent = this.isDual || dualBlock
            ? `${contadoMoney} contado`
            : contadoMoney;
        }

        if (this.msiTarget) {
          if (msiCents > 0) {
            const msiMoney = formatCents(msiCents);
            this.msiTarget.textContent = `o ${msiMoney} a meses sin intereses`;
            this.msiTarget.hidden = false;
          } else {
            this.msiTarget.hidden = true;
          }
        }

        this.syncAvailability();
      }

      onResize() {
        if (!isMobile()) {
          this.setBarVisible(false);
          this.hidden = true;
        } else {
          this.hidden = this.dataset.available !== '1';
          this.syncAvailability();
          this.syncButtonLabel();
          this.checkVisibility();
        }
      }

      syncButtonLabel() {
        if (!this.addBtn || this.addBtn.disabled) return;
        if (!this.fullAddLabel) {
          this.fullAddLabel = this.addBtn.textContent.trim();
        }
        this.addBtn.textContent = this.fullAddLabel;
        requestAnimationFrame(() => {
          if (!this.addBtn || this.addBtn.disabled) return;
          const truncated = this.addBtn.scrollWidth > this.addBtn.clientWidth + 1;
          this.addBtn.textContent = truncated ? 'Agregar' : this.fullAddLabel;
        });
      }

      syncAvailability() {
        if (!this.mainBtn || !this.addBtn) return;
        const soldOut =
          this.mainBtn.disabled || this.mainBtn.dataset.status === 'sold-out';
        if (soldOut) {
          this.dataset.available = '0';
          this.addBtn.disabled = true;
          this.addBtn.textContent =
            this.mainBtn.querySelector('.button__text')?.textContent?.trim() ||
            this.addBtn.textContent;
          this.setBarVisible(false);
          this.hidden = true;
        } else {
          this.dataset.available = '1';
          this.addBtn.disabled = false;
          if (!isMobile()) this.hidden = true;
          else this.hidden = false;
        }
      }

      onStickyAdd(event) {
        event.preventDefault();
        if (!this.mainBtn || this.mainBtn.disabled) return;
        this.mainBtn.click();
      }

      checkVisibility() {
        if (!isMobile() || !this.mainBtn || this.dataset.available !== '1') return;
        const rect = this.mainBtn.getBoundingClientRect();
        const vh = window.innerHeight || document.documentElement.clientHeight;
        const mainVisible = rect.top < vh && rect.bottom > 0;
        this.setBarVisible(!mainVisible);
      }

      setBarVisible(show) {
        if (!isMobile() || this.dataset.available !== '1') {
          show = false;
        }
        this.classList.toggle('is-visible', show);
        document.body.classList.toggle('armonia-sticky-cta-visible', show);
        if (show) this.syncButtonLabel();
      }
    }

    customElements.define('armonia-pdp-sticky-cta', ArmoniaPdpStickyCta);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
